import React from "react";

// After
import { createRoot } from "react-dom/client";

import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";

import thunk from "redux-thunk";
import { loadingBarMiddleware } from "react-redux-loading-bar";
import { errorBarMiddleware } from "ReduxErrorBar";

import reducers from "./reducers";

import MainApp from "./main-app";

import { loadState, saveState } from "./localStorage";

import reduxReset from "redux-reset";

const container = document.getElementById("root");

//const container = document.querySelector(".container-fluid");

// Documentation code const container = document.getElementById('app');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

var persistedState = loadState();

var createStoreWithMiddleware = compose(
  applyMiddleware(thunk, loadingBarMiddleware(), errorBarMiddleware()),
  reduxReset()
)(createStore);

export var store = createStoreWithMiddleware(reducers, persistedState);

store.subscribe(() => {
  saveState(store.getState());
});

root.render(
  <Provider store={store}>
    <MainApp />
  </Provider>
);
